<template>
    <div class="cont-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('langNew.yyqh')}}</div>
        </div>
        <ul class="lang-box">
            <li class="lang" :class="{active: curIdx == key}" @click="change(key,item.link)" v-for="(item,key) in lang" :key="key">
                <div>{{item.name}}</div>
                <div class="arrow"></div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'lang',
    data () {
        return {
            curIdx: 0,
            lang: []
        }
    },
    created(){
        this.lang = this.$t('language.subList');
        let user_lang = localStorage.getItem('user_lang');
        if(user_lang == 'en' || user_lang == ''){
            this.curIdx = 0;
        }else if(user_lang == 'tw'){
            this.curIdx = 1;
        }else if(user_lang == 'jp'){
            this.curIdx = 2;
        }else if(user_lang == 'kr'){
            this.curIdx = 3;
        }else if(user_lang == 'th'){
            this.curIdx = 4;
        }else if(user_lang == 'vn'){
            this.curIdx = 5;
        }else{
            this.curIdx = 6;
        }
    },
    methods: {
        change(key,lang){
            this.curIdx = key;
            localStorage.setItem('user_lang',lang);
            var url = window.location.protocol + '//' + window.location.host;
            window.location.href = url;
        },
        goBack(){
            this.$router.go(-1);
        },
    }
}
</script>
<style scoped>
    .cont-box{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: 50%;
        width: .32rem;
        height: .6rem;
        transform: translateY(-50%);
    }
    .lang-box{
        padding: 1.44rem .3rem;
    }
    .lang-box .lang{
        display: flex;
        justify-content: space-between;
        padding: .4rem 0 .3rem;
        color: #fff;
        font-size: .42rem;
        border-bottom: 1px solid #858585;
    }
    .lang-box .lang.active .arrow{
        width: .4rem;
        height: .2rem;
        border-left: 2px solid #2CAADE;
        border-bottom: 2px solid #2CAADE;
        transform: rotate(-60deg);
    }
</style>



// WEBPACK FOOTER //
// src/pages/lang.vue